/**
 * In-memory Live Share fallback for dev mode (no Teams meeting context).
 * Local user is always presenter. No cross-tab sync.
 * Keeps all 41 E2E tests working without changes.
 */
export class DevLiveShareBridge {
    _state = null;
    _viewState = { documentId: null, currentPage: 1 };
    _isPresenting = false;
    _isSuspended = false;
    _listeners = [];
    get state() {
        return this._state;
    }
    async initialize(initialViewState) {
        this._viewState = initialViewState;
        this._state = this.buildState();
    }
    async startPresenting() {
        this._isPresenting = true;
        this._isSuspended = false;
        this.emitStateChange(true);
    }
    async stopPresenting() {
        this._isPresenting = false;
        this.emitStateChange(true);
    }
    async updateViewState(viewState) {
        this._viewState = viewState;
        this.emitStateChange(true);
    }
    async beginSuspension() {
        this._isSuspended = true;
        this.emitStateChange(true);
    }
    async endSuspension() {
        this._isSuspended = false;
        this.emitStateChange(true);
    }
    onStateChanged(cb) {
        this._listeners.push(cb);
        return () => {
            this._listeners = this._listeners.filter((l) => l !== cb);
        };
    }
    dispose() {
        this._listeners = [];
        this._state = null;
    }
    buildState() {
        let type;
        if (this._isPresenting) {
            type = 'activePresenter';
        }
        else if (this._isSuspended) {
            type = 'suspendFollowPresenter';
        }
        else {
            type = 'local';
        }
        return {
            type,
            value: this._viewState,
            followingUserId: null,
            otherUsersCount: 0,
            isLocalValue: true,
        };
    }
    emitStateChange(local) {
        this._state = this.buildState();
        for (const cb of this._listeners) {
            cb(this._state, local);
        }
    }
}
//# sourceMappingURL=DevLiveShareBridge.js.map